module.exports = __webpack_public_path__ + "static/media/ts15cr823.629194e0.png";